import createLucideIcon from '../createLucideIcon';

const FastForward = createLucideIcon('FastForward', [
  ['polygon', { points: '13 19 22 12 13 5 13 19', key: '587y9g' }],
  ['polygon', { points: '2 19 11 12 2 5 2 19', key: '3pweh0' }],
]);

export default FastForward;
